<template>
  <div
    style="
      position: fixed;
      top: 60px;
      background-color: white;
      right: 0;
      left: 60px;
      height: 60px;
      line-height: 60px;
      padding: 0 20px 0 12px;
      display: flex;
      justify-content: space-between;
      z-index: 2;
      box-shadow: 0 0 1px grey;
    "
  >
    <div>
      <a-button
        @click="extNav('assure')"
        type="ghost"
        shape="round"
        style="margin: 0 4px"
        :style="[
          isActiveExt('assure')
            ? {
                backgroundColor: '#2185d0',
                color: 'white',
                border: '1px solid #2185d0',
              }
            : {},
        ]"
      >
        Assurés
      </a-button>
      <a-button
        @click="extNav('contrat')"
        type="ghost"
        shape="round"
        style="margin: 0 4px"
        :style="[
          isActiveExt('contrat')
            ? {
                backgroundColor: '#f2711c',
                color: 'white',
                border: '1px solid #f2711c',
              }
            : {},
        ]"
      >
        Contrats
      </a-button>
      <a-button
        @click="extNav('prestation')"
        type="ghost"
        shape="round"
        style="margin: 0 4px"
        :style="[
          isActiveExt('prestation')
            ? {
                backgroundColor: '#6435c9',
                color: 'white',
                border: '1px solid #6435c9',
              }
            : {},
        ]"
      >
        Prestations
      </a-button>
      <a-button
        @click="extNav('cotisation')"
        type="ghost"
        shape="round"
        style="margin: 0 4px"
        :style="[
          isActiveExt('cotisation')
            ? {
                backgroundColor: '#21ba45',
                color: 'white',
                border: '1px solid #21ba45',
              }
            : {},
        ]"
      >
        Cotisations
      </a-button>
    </div>

    <div>
      <a-input-search
        v-model:value="$store.state.filtreTable"
        placeholder="Recherche"
      ></a-input-search>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExtractionBigMenu",
  methods: {
    extNav(extType) {
      this.$router.push({
        name: "extraction",
        params: {
          extType: extType,
        },
      });
    },
    isActiveExt(extType) {
      return this.$route.params.extType == extType;
    },
  },
  mounted() {
    this.$store.state.filtreTable = "";
  },
};
</script>

<style>
</style>
